import { Experiment } from "@func-core/core/domain/view-models";

export const EXPERIMENT_VARIANTS = {
  ENABLED: "enabled",
  DISABLED: "disabled",
  SAVE60: "save60",
  SAVE40: "save40",
} as const;

export const EXPERIMENT_IDS = {
  CUSTOM_CHECKOUT_SESSION: "custom-checkout-session",
  SMALL_PRINT: "small-print",
  HERO_TITLE: "hero-title",
  HEALTH_FORECAST_HERO_TITLE: "health-forecast-hero-title",
  BECAS_DISCOUNT_TENURE: "becas-discount-tenure",
  NOT_REQUIRED_CHIP_NUMBER_SPAIN: "not-required-chip-number-spain",
  TRUSTPILOT_MICRO_TRUSTSCORE: "trustpilot-micro-trustscore",
  REMOVE_DOUBLE_CTA_ON_HERO_MOBILE: "remove-double-cta-on-hero-mobile",
  STICKY_BUTTON_ON_QUOTES_PAGE: "sticky-button-on-quotes-page",
} as const;

export const EXPERIMENTS: Experiment[] = [
  {
    id: EXPERIMENT_IDS.CUSTOM_CHECKOUT_SESSION,
    name: "Custom Checkout Session",
    isPreQuotes: false,
    variants: [
      { id: EXPERIMENT_VARIANTS.ENABLED, name: "Custom Checkout Session Enabled", weight: 1 },
      { id: EXPERIMENT_VARIANTS.DISABLED, name: "Custom Checkout Session Disabled", weight: 0 },
    ],
    countries: [],
  },
  {
    id: EXPERIMENT_IDS.SMALL_PRINT,
    name: "Small Print",
    isPreQuotes: false,
    variants: [
      { id: EXPERIMENT_VARIANTS.ENABLED, name: "Small Print Enabled", weight: 0.5 },
      { id: EXPERIMENT_VARIANTS.DISABLED, name: "Small Print Disabled", weight: 0.5 },
    ],
    countries: [],
  },
  {
    id: EXPERIMENT_IDS.HERO_TITLE,
    name: "Hero Title",
    isPreQuotes: true,
    variants: [
      {
        id: EXPERIMENT_VARIANTS.ENABLED,
        name: "Hero title on Landing Page is 'El mejor seguro de salud para perros y gatos.'",
        weight: 0,
      },
      {
        id: EXPERIMENT_VARIANTS.DISABLED,
        name: "Hero title on Landing Page is 'Tu familia es para siempre. Su seguro también.'",
        weight: 1,
      },
    ],
    countries: ["ES"],
  },
  {
    id: EXPERIMENT_IDS.HEALTH_FORECAST_HERO_TITLE,
    name: "Health Forecast Hero Title",
    isPreQuotes: true,
    variants: [
      { id: EXPERIMENT_VARIANTS.ENABLED, name: "Health Forecast Hero Title Enabled", weight: 0.5 },
      {
        id: EXPERIMENT_VARIANTS.DISABLED,
        name: "Health Forecast Hero Title Disabled",
        weight: 0.5,
      },
    ],
    countries: ["ES"],
  },
  {
    id: EXPERIMENT_IDS.BECAS_DISCOUNT_TENURE,
    name: "Becas Discount Tenure",
    isPreQuotes: false,
    variants: [
      { id: EXPERIMENT_VARIANTS.SAVE60, name: "Becas Discount Tenure save 60", weight: 0.33 },
      { id: EXPERIMENT_VARIANTS.SAVE40, name: "Becas Discount Tenure save 40", weight: 0.33 },
      { id: EXPERIMENT_VARIANTS.DISABLED, name: "Becas Discount Tenure Disabled", weight: 0.34 },
    ],
    countries: ["ES"],
  },
  {
    id: EXPERIMENT_IDS.NOT_REQUIRED_CHIP_NUMBER_SPAIN,
    name: "Not Required Chip Number Spain",
    isPreQuotes: false,
    variants: [
      { id: EXPERIMENT_VARIANTS.ENABLED, name: "Chip Number Not Required for Spain", weight: 1 },
      { id: EXPERIMENT_VARIANTS.DISABLED, name: "Chip Number Required for Spain", weight: 0 },
    ],
    countries: ["ES"],
  },
  {
    id: EXPERIMENT_IDS.TRUSTPILOT_MICRO_TRUSTSCORE,
    name: "Trustpilot Micro Trustscore",
    isPreQuotes: true,
    variants: [
      { id: EXPERIMENT_VARIANTS.ENABLED, name: "Trustpilot Micro Trustscore Enabled", weight: 0 },
      {
        id: EXPERIMENT_VARIANTS.DISABLED,
        name: "Trustpilot Micro Trustscore Disabled",
        weight: 1,
      },
    ],
  },
  {
    id: EXPERIMENT_IDS.REMOVE_DOUBLE_CTA_ON_HERO_MOBILE,
    name: "Remove Double CTA on Hero Mobile",
    isPreQuotes: true,
    variants: [
      {
        id: EXPERIMENT_VARIANTS.ENABLED,
        name: "Remove Double CTA on Hero Mobile Enabled",
        weight: 0.5,
      },
      {
        id: EXPERIMENT_VARIANTS.DISABLED,
        name: "Remove Double CTA on Hero Mobile Disabled",
        weight: 0.5,
      },
    ],
  },
  {
    id: EXPERIMENT_IDS.STICKY_BUTTON_ON_QUOTES_PAGE,
    name: "Sticky Button on Quotes Page",
    isPreQuotes: false,
    variants: [
      {
        id: EXPERIMENT_VARIANTS.ENABLED,
        name: "Sticky Button on Quotes Page Enabled",
        weight: 0.5,
      },
      {
        id: EXPERIMENT_VARIANTS.DISABLED,
        name: "Sticky Button on Quotes Page Disabled",
        weight: 0.5,
      },
    ],
    countries: ["ES"],
  },
];
